import { barItemExtensionInstall } from './bar';
import { barItemLabelExtensionInstall } from './label';
import { stackBarAnimationExtensionInstall } from './stackBarAnimation';

export default [
  barItemExtensionInstall,
  barItemLabelExtensionInstall,
  stackBarAnimationExtensionInstall
];
